import bolt from '../assets/images/our-partners/bolt-pharma.jpg'
import hospital from '../assets/images/our-partners/countyhospital.jpg'
import doctorsassociation from '../assets/images/our-partners/doctors-association.jpg'
import diabetes from '../assets/images/our-partners/diabetes-association.jpg'
import magicalpharmacy from '../assets/images/our-partners/magical-pharmacy.jpg'
import pinkpharmacy from '../assets/images/our-partners/pink-pharmacy.jpg'
import wellnessassociation from '../assets/images/our-partners/wellness-association.jpg'
import miragehospital from '../assets/images/our-partners/mirage-hospital.jpg'
import healthypharm from '../assets/images/our-partners/healthy-pharm.jpg'
import karenhospital from '../assets/images/our-partners/karen-hospital.jpg'
import bigpharma from '../assets/images/our-partners/big-pharma.jpg'
import macrosuppliers from '../assets/images/our-partners/macro-suppliers.jpg'

export const partners = [
    {
        id: 1,
        name: "Bolt Pharma",
        image: bolt,
        link:"https://www.boltpharma.co.uk/"
    },
    {
        id: 2,
        name: "County Hospital",
        image: hospital,
        link:"https://www.countyhospital.co.uk/"
    },
    {
        id: 3,
        name: "Doctors Association",
        image: doctorsassociation,
        link:"https://www.doctorsassociation.co.uk/"
    },
    {
        id: 4,
        name: "Pink Pharmacy",
        image: pinkpharmacy,
        link:"https://www.healthypharm.co.uk/"
    },
    {
        id: 5,
        name: "Diabetes Society",
        image: diabetes,
        link:"https://www.magicalpharmacy.co.uk/"
    },
    {
        id: 6,
        name: "Mirage Hospital",
        image: miragehospital,
        link:"https://www.miragehospital.co.uk/"
    },
    {
        id: 7,
        name: "Healthy Pharm",
        image: healthypharm,
        link:"https://www.healthypharm.co.uk/"
    },
    {
        id: 8,
        name: "Wellness Association",
        image: wellnessassociation,
        link:"https://www.wellnessassociation.co.uk/"
    },
    {
        id: 9,
        name: "Magical Pharmacy",
        image: magicalpharmacy,
        link:"https://www.magicalpharmacy.co.uk/"
    },
    {
        id: 10,
        name: "Karen Hospital",
        image: karenhospital,
        link:"https://www.karenhospital.co.uk/"
    },
    {
        id: 11,
        name: "Big Pharma",
        image: bigpharma,
        link:"https://www.boltpharma.co.uk/"
    },
    {
        id: 12,
        name: "Macro Suppliers",
        image: macrosuppliers,
        link:"https://www.countyhospital.co.uk/"
    }
]
